import { reportStateEnum, reportTypeEnum } from '../report';

export const reportStateColors: Record<number, { background: string; text: string }> = {
  [reportStateEnum.VALIDATED]: { background: '#00B050', text: 'black' },
  [reportStateEnum.REPORTFILLED]: { background: '#88D8A8', text: 'black' },
  [reportStateEnum.REPORT]: { background: '#FFC000', text: 'black' },
  [reportStateEnum.PLANNING]: { background: '#A3D9FF', text: 'black' },
  [reportStateEnum.NEEDS]: { background: '#E0E0E0', text: 'black' },
};

export const reportTypeColors: Record<number, { background: string; text: string }> = {
  [reportTypeEnum.ABSENT]: { background: 'crimson', text: 'white' },
  [reportTypeEnum.SITE]: { background: '#79d2e6', text: 'black' },
};

export const getReportStateColor = (
  state: number,
  position: 'background' | 'text'
): string => {
  return reportStateColors[state]?.[position] ?? '#E0E0E0';
};

export const getReportTypeColor = (
  type: number,
  position: 'background' | 'text'
): string => {
  return reportTypeColors[type]?.[position] ?? '';
};
